import React, { FC } from "react";

import Backdrop, { BackdropProps } from "@mui/material/Backdrop";

export const MuiBackdrop: FC<BackdropProps> = (props) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.tooltip + 2,
      }}
      {...props}
    />
  );
};
